import React from 'react';
import { Box } from '@mui/material';
import Pagination from '../../../../../dsasComponents/pagination/Pagination.js';
import PlayerCard from './PlayerCard';
import { faPlus, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import DsasButton from '../../../../components/DsasButton/DsasButton.js';
import useStyles from '../../../../../styles/global-mui.js';
import { Can } from '../../../../../permissions/Can.js';
import { PERMISSIONS } from '../../../../../permissions/permissionKeys.js';

const PlayerResults = ({ showCreate, handleSelectOtherPlayer, players, onExportCSV, actions = [], removePlayerFromList, exportResult=true, showExport=true, showPicture=true, searchMode, fieldsValidator }) => {
  const classes = useStyles();
  //TODO opti evol : ajouter la notion de mandatory dans le filtersConfig
  const mantatoryFieldsInfo = searchMode === 'simple' ? 'Nom, Discipline' : 'Discipline, Compétition, Équipe';
  const isFiltersValids = typeof fieldsValidator === 'function'
  ? fieldsValidator()
  : false;

  if(!isFiltersValids){
    return <Box className='left-medium-wrapper'>{`Veuillez saisir les filtres obligatoires (${mantatoryFieldsInfo}).`}</Box>;
  }

  if (players && players.length>0) {
    return(
      <>
    {/*Bouton export resultat CSV*/}
    {exportResult && <Box className='left-medium-wrapper'>
      {/* <Button variant="contained" onClick={onExportCSV}>
        Exporter les résultats en CSV
      </Button> */}
      <Can permission={PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_EXPORTCSV}>
       <DsasButton label="Exporter les résultats en CSV" icon={faUserPlus} onClick={onExportCSV} variant = 'secondary' />
      </Can>
    </Box>}
    <Box className='large-separator medium-padding'></Box>
    {/*resultats*/}
      <Box className='padding-wrapper'>
        <Pagination items={players} type='Joueurs' className={classes.customTablePagination}>
          {players.map((player) => (
              <PlayerCard player={player} 
              actions={actions} 
              removePlayerFromList={removePlayerFromList} 
              className={classes.customCard} 
              showExport={showExport}
              showPicture={showPicture}
              />
          ))}
        </Pagination>
      </Box>
      </>)

  }

  return <>
    <Box className='left-medium-wrapper'>Aucun joueur trouvé.</Box>
   {showCreate && <Box className='centered-medium-wrapper'>
        <Can permission={PERMISSIONS.SPORT_PLAYER_HOME_BUTTON_CREATE}>
          <DsasButton label="Créer avec les données saisies" icon={faPlus} onClick={handleSelectOtherPlayer} variant = 'secondary' />
        </Can>
      </Box>}
      </>
  
  
};

export default PlayerResults;
